import { projectNameToHubName } from '@/data/Hubs/hubName'
import type { Hub, RawHub } from '@/data/Hubs/types'
import type { ProjectInList } from '@/modules/Projects/useProjects'
import { camelCase } from 'change-case/keys'
import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'

export const useHubStore = defineStore('hubs', () => {
  const hubs: Ref<Map<string, Hub>> = ref(new Map())

  /**
   * Hubs don't have WS events, we need to watch for Project updates.
   * They return different data than the hub endpoint.
   */
  function patch(project: ProjectInList) {
    const hub = hubs.value.get(project.id)
    if (!hub) return

    const name = projectNameToHubName(project.name ?? '')
    Object.assign(hub, { ...project, name })
  }

  function upsertRaw(...hubList: RawHub[]) {
    for (const rawHub of hubList) {
      hubs.value.set(rawHub.id, camelCase(rawHub, Infinity) as Hub)
    }
  }

  return { hubs, patch, upsertRaw }
})
